import api from '@/api'
import {
  SET_LOADING_AUTO_CLEAN,
  SET_AUTO_CLEAN_PARAMS,
  SET_AUTO_CLEAN_LIST,
  SET_AUTO_CLEAN_LIST_PAGE_NUM,
  SET_AUTO_CLEAN_LIST_PAGE_SIZE,
  SET_AUTO_CLEAN_LIST_TOTAL,
  SET_LOADING_TIME_RULE,
  SET_TIME_RULE_LIST,
} from './mutation-types'
import _ from 'lodash'

const initQuery = () => ({
  startDate: '',
  endDate: '',
  userId: '',
  taskIds: '',
  pageSize: 50,
  pageNum: 1,
})
const state = {
  loadingAutoClean: false,
  autoClean: {
    autoCleanList: [],
    query: initQuery(),
    listPageTotal: 0,
  },
  loadingTimeRule: false,
  timeList: [],
}

const mutations = {
  [SET_AUTO_CLEAN_LIST](state, payload) {
    state.autoClean.autoCleanList = payload
  },
  [SET_LOADING_AUTO_CLEAN](state, payload) {
    state.loadingAutoClean = payload
  },
  [SET_AUTO_CLEAN_PARAMS](state, payload) {
    state.autoClean.query = {
      ...state.autoClean.query,
      ...payload,
    }
  },
  [SET_AUTO_CLEAN_LIST_PAGE_NUM] (state, payload) {
    state.autoClean.query.pageNum = payload
  },
  [SET_AUTO_CLEAN_LIST_PAGE_SIZE] (state, payload) {
    state.autoClean.query.pageSize = payload
  },
  [SET_AUTO_CLEAN_LIST_TOTAL] (state, payload) {
    state.autoClean.listPageTotal = payload
  },
  [SET_TIME_RULE_LIST](state, payload) {
    state.timeList = payload
  },
  [SET_LOADING_TIME_RULE](state, payload) {
    state.loadingTimeRule = payload
  },

}

const actions = {
  async getAutoClearLog({ commit, state }) {
    try {
      let query = {}
      _.forIn(state.autoClean.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
      }
      commit(SET_LOADING_AUTO_CLEAN, true)
      const { data: {items, total} } = await api.storageApi.getAutoClearLog(params)
      commit(SET_LOADING_AUTO_CLEAN, false)
      commit(SET_AUTO_CLEAN_LIST, items)
      commit(SET_AUTO_CLEAN_LIST_TOTAL, total)
      return items
    } catch (error) {
      commit(SET_LOADING_AUTO_CLEAN, false)
      commit(SET_AUTO_CLEAN_LIST, [])
      commit(SET_AUTO_CLEAN_LIST_TOTAL, 0)
      return null
    }
  },
  searchAutoClearLog({commit, dispatch}, payload) {
    commit(SET_AUTO_CLEAN_LIST_PAGE_NUM, payload.pageNum)
    dispatch('getAutoClearLog')
  },
  initAutoClearLog ({dispatch}) {
    dispatch('getAutoClearLog')
  },
  setAutoCleanListQuery ({commit, dispatch}, payload) {
    commit(SET_AUTO_CLEAN_PARAMS, payload)
  },
  async changeAutoCleanListPage ({commit, dispatch}, payload) {
    commit(SET_AUTO_CLEAN_LIST_PAGE_NUM, payload.currentPage)
    if (payload.refresh) dispatch('getAutoClearLog')
  },
  changeAutoCleanPageSize ({commit, dispatch}, payload) {
    commit(SET_AUTO_CLEAN_LIST_PAGE_SIZE, payload.pageSize)
    dispatch('changeAutoCleanListPage', {currentPage: 1})
  },
  async getTimerList({ commit, state }) {
    try {
      commit(SET_LOADING_TIME_RULE, true)
      const { data, code } = await api.storageApi.getTimerList()
      commit(SET_LOADING_TIME_RULE, false)
      commit(SET_TIME_RULE_LIST, code === 200 ? data : [])
      return data
    } catch (error) {
      commit(SET_LOADING_TIME_RULE, false)
      commit(SET_TIME_RULE_LIST, [])
      return null
    }
  },
  async addOrEditTimer({ commit, dispatch }, payload) {
    const res = await api.storageApi.addOrEditTimer(payload)
    if (res.code === 200) {
      dispatch('getAutoClearLog')
    }
    return res
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
